import React, { useState } from "react";
import Navbar from "../components/Navbar";

const ChatBot = () => {
  const [message, setMessage] = useState("");
  const [chatHistory, setChatHistory] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    // Add user message
    setChatHistory(prev => [
      ...prev,
      { sender: "user", text: message }
    ]);

    const userMessage = message.trim().toLowerCase();
    setMessage("");

    // Simulated responses
    let botResponse = { text: "", data: null };

    if (userMessage.includes("help")) {
      botResponse.text = 
        "Here is what you can ask:\n" +
        "- 'What are the top risks?'\n" +
        "- 'Show high risk clinics'\n" +
        "- 'Hello'";
    } else if (["hi", "hello", "hey"].some(word => userMessage.includes(word))) {
      botResponse.text = "Hello 👋 I can show you clinic risk information. Try asking 'top risks'.";
    } else if (userMessage.includes("top") && userMessage.includes("risk")) {
      botResponse.text = "Top risk clinics:";
      // Simulated data
      botResponse.data = [
        { id: 1, clinic_name: "City Health Center", last_risk: 95 },
        { id: 2, clinic_name: "Sunrise Clinic", last_risk: 90 },
        { id: 3, clinic_name: "WellCare Clinic", last_risk: 88 },
        { id: 4, clinic_name: "Downtown Medical", last_risk: 85 },
        { id: 5, clinic_name: "Greenfield Health", last_risk: 82 },
      ];
    } else {
      botResponse.text = "Sorry, I don’t understand yet. Type 'help' to see what I can do.";
    }

    setChatHistory(prev => [...prev, { sender: "bot", ...botResponse }]);
  };

  return (
    <div>
      <Navbar />

      <div className="page-container">
        <h1 className="page-title">Chat Assistant 🤖</h1>

        <div className="page-card">
          {/* Chat messages */}
          <div className="chat-box">
            {chatHistory.map((msg, i) => (
              <div
                key={i}
                className={`chat-msg ${msg.sender === "user" ? "chat-user" : "chat-bot"}`}
              >
                <div style={{ whiteSpace: "pre-line" }}>{msg.text}</div>

                {msg.data && (
                  <ul className="mt-2 space-y-2 text-sm">
                    {msg.data.map(clinic => (
                      <li key={clinic.id} className="p-2 rounded bg-gray-100">
                        <strong>{clinic.clinic_name}</strong>
                        <br />
                        Risk score: {clinic.last_risk}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          {/* User guidance */}
          <div className="text-sm text-gray-500 mb-2">
            💡 Try typing: <strong>help</strong>, <strong>hello</strong>, or <strong>What are the top risks?</strong>
          </div>

          {/* Input form */}
          <form onSubmit={handleSubmit} className="flex gap-3">
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder='Ask something… e.g. "help" or "top risks"'
              className="modern-input flex-1"
            />
            <button className="modern-btn">Send</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChatBot;